export const buttonStyle = {
    marginLeft: '10px',
  }

export const iconStyle = {
  height: '30px',
  width: '30px'
}
